import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigPreAuth } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const verifyCred = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfigPreAuth(tokens),
    apiPath: APIEndPoints.APPAuth,
    method: 'POST',
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { verifyCred }
